var $7cacc29a1e5f4fbe$exports = {};
$7cacc29a1e5f4fbe$exports = {
  "Clear search": "Vymaza\u0165 vyh\u013Ead\xE1vanie"
};
export { $7cacc29a1e5f4fbe$exports as default };